// firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDSNSSinntMOqVoEinsckPC3MOhGmRHY3M",
  authDomain: "myborderpal.firebaseapp.com",
  projectId: "myborderpal",
  storageBucket: "myborderpal.firebasestorage.app",
  messagingSenderId: "963619610503",
  appId: "1:963619610503:web:0cce56c652967ba1fe7d22",
  measurementId: "G-Z30ZNVFLYB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Auth providers
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

export default app;
